module.exports = __webpack_public_path__ + "img/main block illustration.b9f2cc95.png";